<template>
  <div class="footer" id="contactUs">
    <div class="whole">
      <p>
        <span>联系我们</span>
      </p>
      <div class="w-u">
        <span>客服热线：400-000-2436（服务时间：9：00-18：00）</span>
        <br />联系地址：西安市雁塔区科技路165-203号旺座国际B座8层
        <!--        <ul>-->
        <!--          <li>-->
        <!--            <span>客服热线：400-000 2436（服务时间：9：00-18：00）</span>-->
        <!--          </li>-->
        <!--        </ul>-->
        <!--        <ul>-->
        <!--          <li>-->
        <!--            <span>商务合作：400-000 2436</span>-->
        <!--          </li>-->
        <!--        </ul>-->
        <!--        <ul>-->
        <!--          <li>-->
        <!--          <span>联系地址：西安市雁塔区科技路165-203号旺座国际B座30层</span>-->
        <!--          </li>-->
        <!--        </ul>-->
      </div>
    </div>
    <!--    <div class="join">-->
    <!--      <p>-->
    <!--        <span>招商加盟</span>-->
    <!--      </p>-->
    <!--      <div class="j">-->
    <!--        <span>加盟条件</span>-->
    <!--        <br>加盟服务-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="wechat">
      <!--      <el-row class="card">-->
      <!--        <el-col :span="8" v-for="(o, index) in 2" :key="o" :offset="index > 0 ? 2 : 0">-->
      <div class="card-left">
        <el-card :body-style="{ padding: '0px' }">
          <img src="../assets/image/wx.png" class="image" alt="" />
          <div style="padding: 1px 0 16px" class="wechat-text">
            <!--              <span class="">{{ textList.type }}</span>-->
            <span class="g">爱学思微信</span>
            <!--              <div class="bottom clearfix">-->
            <!--                <span class="g">爱学思公众号</span>-->
            <!--              </div>-->
          </div>
        </el-card>
      </div>
      <div class="card-right">
        <el-card :body-style="{ padding: '0px' }">
          <img src="../assets/image/gzh.jpg" class="image" alt="" />
          <div style="padding: 1px 0 16px" class="wechat-text">
            <!--              <span class="">{{ textList.type }}</span>-->
            <span class="g">爱学思公众号</span>
            <!--              <div class="bottom clearfix">-->
            <!--                <span class="g">爱学思公众号</span>-->
            <!--              </div>-->
          </div>
        </el-card>
      </div>
      <!-- <div class="card-back"> -->
      <!-- <el-card :body-style="{ padding: '0px' }"> -->
      <!-- <img src="../assets/image/apk.png" class="image" alt="" /> -->
      <!-- <div style="padding: 1px 0 16px" class="wechat-text"> -->
      <!--              <span class="">{{ textList.type }}</span>-->
      <!-- <span class="g">爱学思智测星</span> -->
      <!--              <div class="bottom clearfix">-->
      <!--                <span class="g">爱学思公众号</span>-->
      <!--              </div>-->
      <!-- </div> -->
      <!-- </el-card> -->
      <!-- </div> -->
      <!--        </el-col>-->
      <!--      </el-row>-->

      <!--      <img-->
      <!--        src="data:image/png;base64,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"-->
      <!--        alt="" width="158" height="158" class="img-one">-->
      <!--      <span class="w">爱学思微信</span>-->
      <!--      <img-->
      <!--        src="data:image/png;base64,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"-->
      <!--        alt="" width="158" height="158" class="img-two">-->
      <!--      <span class="g">爱学思公众号</span>-->
    </div>
    <div class="icp">
      <a href="https://beian.miit.gov.cn" style="text-decoration-line: none">
        <span>备案号：京ICP备2020035849号-1</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer",
  data() {
    return {
      textList: [
        { id: 1, type: "爱学思微信" },
        { id: 2, type: "爱学思公众号" },
      ],
    };
  },
  methods: {
    callDownLoad() {
      this.$router.push({
        name: "DownloadApp",
      });
    },
  },
};
</script>

<style scoped>
.footer {
  width: 1920px;
  height: 355px;
  margin: auto;
  background: #313131;
}

.contact-us {
  width: 84px;
  height: 22px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}

.whole {
  float: left;
}

.whole p span {
  width: 88px;
  height: 22px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;

  display: inline-block;
  padding: 71px 491px 33px 340px;
}

.w-u {
  padding: 0 0 147px 340px;
  width: 490px;
  height: 82px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 30px;
}

.w-u p {
  /*width: 470px;*/
  /*height: 82px;*/
  /*font-size: 18px;*/
  /*font-family: PingFang SC;*/
  /*font-weight: 400;*/
  /*color: #999999;*/
}

.join {
  float: left;
}

.join p span {
  width: 88px;
  height: 22px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;

  display: inline-block;
  padding: 71px 120px 34px 0;
}

.join .j {
  width: 72px;
  height: 49px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;

  line-height: 30px;
  padding: 0 0 179px 0;
}

.join ul,
.whole ul {
  list-style-type: none;
}

.whole ul li span {
  width: 470px;
  height: 82px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}

.join ul li span {
  width: 70px;
  height: 49px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}

.join-investment {
  width: 85px;
  height: 22px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}

.img-one {
  width: 158px;
  height: 158px;
  background: #e6edf5;
}

.img-two {
  width: 158px;
  height: 158px;
  background: #e6edf5;
}

.wechat {
  float: right;
  /*margin: 60px 335px 68px 0;*/

  display: flex;
}

.card-left .el-card {
  width: 185px;
  height: 219px;
  background: #ffffff;
  border-radius: 9px;

  margin: 68px 37px 68px 0;
}

.card-right .el-card {
  width: 185px;
  height: 219px;
  background: #ffffff;
  border-radius: 9px;

  margin: 68px 335px 68px 0;
}

.card-back .el-card {
  width: 185px;
  height: 219px;
  background: #ffffff;
  border-radius: 9px;

  margin: 68px 0 68px -300px;
}

.card-right {
}

.w {
  width: 87px;
  height: 17px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
}

.g {
  width: 104px;
  height: 17px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.image {
  width: 100%;
  display: block;
}

.wechat-text {
  text-align: center;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.icp {
  margin: auto;
  padding-top: 333px;
}

.icp a span {
  /*width: 200px;*/
  height: 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/view/footer.vue